import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/images/shreelogo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Products", path: "/products" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <motion.nav
      className="bg-gradient-to-r from-blue-50 to-gray-100 text-gray-900 shadow-md sticky top-0 z-50 border-b border-gray-300"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img src={logo} alt="Shree Engineering Logo" className="h-14 w-auto" />
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center justify-center flex-1 space-x-10">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              className={({ isActive }) =>
                `transition font-medium text-lg ${
                  isActive
                    ? "text-blue-900 border-b-2 border-orange-500 pb-1"
                    : "text-gray-700 hover:text-blue-900"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </div>

        {/* Get a Quote Button */}
        <div className="hidden md:flex">
          <Link
            to="/contact"
            className="ml-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-5 rounded-lg shadow-md transition transform hover:scale-105"
          >
            Get a Quote
          </Link>
        </div>

        {/* Mobile hamburger */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(true)}
            className="focus:outline-none flex flex-col justify-between w-6 h-5"
          >
            <span className="block w-6 h-0.5 bg-blue-900"></span>
            <span className="block w-6 h-0.5 bg-blue-900"></span>
            <span className="block w-6 h-0.5 bg-blue-900"></span>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 bg-gradient-to-br from-blue-50 to-gray-100 z-40 flex flex-col items-center justify-center space-y-6 shadow-lg md:hidden"
          >
            {/* Close button */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-5 right-6 text-3xl text-blue-900 font-bold focus:outline-none"
            >
              ✖
            </button>

            {/* Menu items */}
            {navItems.map((item, index) => (
              <motion.div
                key={item.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <NavLink
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
                    `text-2xl font-semibold transition ${
                      isActive
                        ? "text-blue-900 border-b-2 border-orange-500 pb-1"
                        : "text-gray-700 hover:text-blue-900"
                    }`
                  }
                >
                  {item.name}
                </NavLink>
              </motion.div>
            ))}

            {/* Mobile Get a Quote */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: navItems.length * 0.1 }}
            >
              <Link
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="mt-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition transform hover:scale-105"
              >
                Get a Quote
              </Link>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
